import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSubscriptionContext } from '../data-access';
import { ONBOARDING_PATH, Path } from './path';

const RequireSubscription = () => {
  const location = useLocation();
  const { hasAccessToApp, hasNoSubscriptionsTrial } = useSubscriptionContext();

  // Redirect to the /subscribe page when no access
  if (!hasAccessToApp) {
    return <Navigate to={Path.PAYWALL} replace />;
  }

  return <Outlet />;
};

export default RequireSubscription;
